module.exports = __webpack_public_path__ + "img/15.2b0067aa.png";